import "react-toastify/dist/ReactToastify.css";
import { CsvUploader } from "@common/UploadCsvTemplate";
import LoadingIcon from "@common/LoadingIcon";
import { departmentHeaderMapping } from "@services/TranslateCsvHeaders";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import { expectedDepartmentHeaders } from "@constants/CsvHeaders";
import { sampleDepartmentData } from "@constants/SampleData";
import { UseDepartmentGroupCsvUpload } from "./hooks/useDepartmentGroupCsvUpload";

const DepartmentGroupCsvUploadPage: React.FC = () => {
  const form = UseDepartmentGroupCsvUpload();

  return (
    <div className="relative">
      {(form.loading || form.isProcessing) && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-5 rounded-lg shadow-lg flex items-center justify-center">
            <LoadingIcon
              bodyText={
                form.isProcessing
                  ? `${form.procesedCount || 0} / ${form.csvData.length || 0}`
                  : ""
              }
              footerText={messages.csv.do_not_close}
            />
          </div>
        </div>
      )}
      <CsvUploader
        titleText={pageHeaders.KAKELY.csvUploadDepartmentGroup}
        expectedContactHeaders={expectedDepartmentHeaders}
        uploadHandler={form.handleCsvUpload}
        onCancel={form.onCancel}
        csvData={form.csvData}
        setCsvData={form.setCsvData}
        sampleData={sampleDepartmentData}
        failedUsers={form.failedDepartments}
        templateName={`部署用CSVテンプレート_${form.currentDate}`}
        headerMapping={departmentHeaderMapping}
        fromPage={"department"}
      />
    </div>
  );
};

export default DepartmentGroupCsvUploadPage;
